import { Periodo } from "shared/models/Periodo";

export const formatPeriodo = (params : URLSearchParams) => {
  if (params.has('mes') && params.has('anio')) {
    return {mes: parseInt(params.get('mes')), anio: parseInt(params.get('anio'))} as Periodo;
  }
  return null;
}
